import _toConsumableArray from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  id: "app"
};
var _hoisted_2 = {
  key: 1,
  class: "layout-wrapper"
};
var _hoisted_3 = {
  key: 2
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  key: 3
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Toast = _resolveComponent("Toast");
  var _component_router_view = _resolveComponent("router-view");
  var _component_page_loading = _resolveComponent("page-loading");
  var _component_AppLayout = _resolveComponent("AppLayout");
  var _component_loading_indicator = _resolveComponent("loading-indicator");
  var _component_PortalError = _resolveComponent("PortalError");
  var _component_PortalOther = _resolveComponent("PortalOther");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Toast), $data.tenantExamined && $data.validTenant || $data.onboardingPage ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([{
      'login-layout-wrapper': $options.isLoginLayout,
      'login-dark-background': $options.getCurrentTheme() === $options.UI_THEMES.DARK,
      'onboarding-layout-wrapper': $data.onboardingPage
    }, "layout-wrapper"])
  }, [$data.onboardingPage || $options.isLoginLayout ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      'overflow-x': $data.onboardingPage ? 'hidden' : 'auto'
    }),
    class: "content"
  }, [_withDirectives(_createVNode(_component_router_view, null, null, 512), [[_vShow, $data.pageLoaded]]), !$data.pageLoaded ? (_openBlock(), _createBlock(_component_page_loading, {
    key: 0
  })) : _createCommentVNode("", true)], 4)) : (_openBlock(), _createBlock(_component_AppLayout, {
    key: 1,
    "show-sidebar": $options.showSidebar
  }, null, 8, ["show-sidebar"])), _createVNode(_component_loading_indicator, null, {
    default: _withCtx(function () {
      return _toConsumableArray(_cache[0] || (_cache[0] = [_createTextVNode(" ", -1)]));
    }),
    _: 1
  })], 2)) : !_ctx.configLoaded && $data.tenantExamined && !$data.validTenant ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_PortalError)])) : _ctx.configLoaded && $data.tenantExamined && !$data.validTenant ? (_openBlock(), _createElementBlock("div", _hoisted_3, [$data.tenantId ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Invalid Tenant: " + _toDisplayString($data.tenantId), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_PortalOther)]))])) : !$data.tenantId ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_PortalOther)])) : _createCommentVNode("", true)]);
}